import styled from '@emotion/styled';
import React, { Fragment } from 'react';
import { themeGet } from 'styled-system';
import { Box, Container as RooContainer, Text } from 'roo-ui/components';
import { PropertyCardSkeleton } from 'components/PropertyCard';
import Property from './Property';
import { mediaQuery } from 'lib/styledSystem';
import { useSelector } from 'react-redux';
import { getRecommendedPropertyAvailabilityCardsData, getIsLoading } from 'store/recommendedProperty/recommendedPropertySelectors';
import { useDataLayer } from 'hooks/useDataLayer';
import { useMount } from 'react-use';

export const Container = styled(RooContainer)`
  opacity: ${(props) => (props.isHidden ? 0 : 1)};
  transition: opacity 0.4s ease-in-out;
`;

export const CardsWrapper = styled(Box)`
  display: flex;
  > * {
    width: 100%;
    margin-right: ${themeGet('space.4')};
  }

  ${mediaQuery.minWidth.sm} {
    margin-right: 0;
  }

  ${mediaQuery.minWidth.md} {
    display: flex;
    > * {
      width: 32%;
      margin-right: ${themeGet('space.4')};

      &:last-child {
        margin-right: ${themeGet('space.0')};
      }
    }
  }
`;

const Skeleton = () => (
  <Fragment>
    <PropertyCardSkeleton />
    <PropertyCardSkeleton />
    <PropertyCardSkeleton />
  </Fragment>
);

const Properties = () => {
  const { emitInteractionEvent } = useDataLayer();
  const propertyCards = useSelector(getRecommendedPropertyAvailabilityCardsData);
  const isLoading = useSelector(getIsLoading);
  const isHidden = !isLoading && !propertyCards.length;

  useMount(() => {
    emitInteractionEvent({
      type: 'Recommended Properties',
      value: 'Recommended Properties Visible',
    });
  });

  return (
    <Container isHidden={isHidden} py={8} px={0}>
      <Text display="block" fontSize="md" fontWeight="bold" data-testid="header">
        You might also like
      </Text>
      <CardsWrapper my={4} flexDirection={['column', 'row']} flexWrap="wrap" justifyContent={['space-between']}>
        {isLoading ? (
          <Skeleton />
        ) : (
          propertyCards.map((card, index) => <Property {...card} key={`related-property-${index}`} index={index} />)
        )}
      </CardsWrapper>
    </Container>
  );
};

export default Properties;
